export default __webpack_public_path__ + "static/media/image-ph-study-report-n-w.2f4f6edd.webp";